const LETTERS = [
  ['R', '#FF4444'], ['A', '#FFD700'], ['F', '#00CC66'], ['F', '#4488FF'],
  ['L', '#AA44FF'], ['E', '#FF66AA'], ['S', '#FFAA00'],
];

const SIZES = {
  sm: 'text-lg',
  md: 'text-3xl',
  lg: 'text-4xl sm:text-5xl',
};

export const BrandLogo = ({ size = 'sm', className = '' }) => (
  <div
    className={`inline-flex items-baseline font-black leading-none tracking-tight select-none ${SIZES[size]} ${className}`}
    style={{ fontFamily: "'Arial Black', 'Helvetica Neue', sans-serif" }}
    aria-label="Raffles R Us"
    data-testid="brand-logo"
  >
    {LETTERS.map(([ch, color], i) => (
      <span key={i} style={{ color, textShadow: size === 'sm' ? 'none' : '2px 2px 0 rgba(0,0,0,0.45)' }}>{ch}</span>
    ))}
    <span className="w-[0.35em]" />
    <span className="inline-block" style={{ color: '#FFD700', transform: 'scaleX(-1)' }}>R</span>
    <span className="ml-[0.1em] text-white">US</span>
  </div>
);
